//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowDebugInfo: FeatureFlag = {"Id":"ShowDebugInfo","Label":"[10.21]Show debug endpoint information","Impact":"When enabled, the /Api/v1/Debug endpoint returns diagnostic information. When disabled, returns 200 with empty body. Works with UseGatewayApiDebug to determine source of debug data.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
